class LineQueue2 {
    constructor(maxSize) {
        this.queue = [];
        this.backupQueue = [];
        this.maxSize = maxSize;
    }

    clear() {
        this.queue = [];
        this.backupQueue = [];
    }

    resize(maxSize) {
        this.maxSize = maxSize;
        if (this.queue.length > this.maxSize) {
            this.queue = this.queue.slice(this.queue.length - this.maxSize);
        }
    }

    enqueue(element) {
        if (this.queue.length >= this.maxSize) {
            this.dequeue();
        }
        const x = Math.round(element.x * 10) / 10;
        const y = Math.round(element.y * 10) / 10;
        this.queue.push({x: x, y: y});
        this.backupQueue.push({x: x, y: y})
    }

    dequeue() {
        if (this.isEmpty()) {
            throw new Error("Queue underflow");
        }
        return this.queue.shift();
    }

    isEmpty() {
        return this.size() === 0;
    }


    size() {
        return this.queue.length;
    }

    *[Symbol.iterator]() {
        for (let item of this.queue) {
            yield item;
        }
    }

    peek() {
        return this.queue[0];
    }

    last(){
        return this.queue[this.queue.length - 1];
    }
}

export default LineQueue2;
